<div class="clamper">
    <div
        class="host fs-md-18"
        #host
        [ngClass]="{ clamped: isClamped && collapsed }"
        [style.--clamper-max-lines]="maxLines"
        [style.--clamper-minimum-height]="minimumHeight ? minimumHeight + 'px' : null"
    >
        <div *ngIf="hasText; else projectedContent" class="host-html-content" [innerHTML]="text"></div>
        <ng-template #projectedContent>
            <ng-content></ng-content>
        </ng-template>
    </div>

    <div class="mt-2 position-relative text-end d-print-none">
        <button type="button" class="read-button text-green cursor bg-transparent border-0 p-0" [hidden]="!isClamped || !collapsed" [attr.aria-expanded]="false" (click)="toggle()">
            {{ readMoreLabel }}
            <i class="icon-gard-arrow-down"></i>
        </button>
        <button type="button" class="read-button text-green cursor bg-transparent border-0 p-0" [hidden]="!isClamped || collapsed" [attr.aria-expanded]="true" (click)="toggle()">
            {{ readLessLabel }}
            <i class="icon-gard-arrow-up"></i>
        </button>
    </div>
</div>
